<template>
  <div>
    <LoadingState v-if="!status.isLoaded" :size="50" class="pt-2" />
    <div v-if="status.isLoaded && domain">
      <PageTitle>
        <div class="mr-2">{{ domain.domain }}</div>
        <HorizontalList :items="headerItems()" />
        <template #actions>
          <DropDown :items="menuItems()">
            <Btn>{{ $t("global.actions") }}</Btn>
          </DropDown>
        </template>
      </PageTitle>
      <Card :title="$t('global.service')" class="mb-4">
        <div class="d-flex">
          <div class="flex-fill">
            <a :href="`http://${domain.domain}`" target="_blank">{{ domain.domain }}</a>
          </div>
          <div>{{ domain.formattedCreated }}</div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import { getContactSupport, getDeleteService } from "@/utils/serviceMenuOptions";
import Btn from "@/components/display/Btn";
import Card from "@/components/display/Card";
import DropDown from "@/components/display/DropDown";
import HorizontalList from "@/components/display/HorizontalList";
import LoadingState from "@/components/display/LoadingState";
import PageTitle from "@/components/display/PageTitle";
import store from "@/store";

export default {
  name: "DomainDetailPage",
  components: {
    Btn,
    Card,
    DropDown,
    HorizontalList,
    LoadingState,
    PageTitle,
  },
  props: {
    domainId: [Number, String],
  },
  setup(props, { root }) {
    const domain = computed(() => store.getters["domains/getItem"]);
    const status = computed(() => store.getters["domains/getItemStatus"]);

    const headerItems = () => [
      {
        key: root.$t("global.service"),
        value: domain.value?.description,
      },
      {
        key: root.$t("global.price"),
        value: domain.value?.billing?.price,
      },
      {
        key: root.$t("global.renewal"),
        value:
          domain.value.billing && domain.value.billing.formattedNextBillDate
            ? domain.value.billing.formattedNextBillDate
            : root.$t("global.na"),
      },
    ];

    const menuItems = () => {
      const items = [];
      items.push(getContactSupport(domain.value), getDeleteService(domain.value));
      return items.filter((i) => i !== null);
    };

    onMounted(() => {
      store.dispatch("domains/get", props.domainId);
    });

    return {
      headerItems,
      menuItems,
      domain,
      status,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.host-attributes {
  font-size: 0.875rem;
  .attribute {
    display: flex;
    align-items: baseline;
    @include media-breakpoint-up(md) {
      &:not(:last-child) {
        &::after {
          margin-right: 1rem;
          margin-left: 1rem;
          content: "|";
        }
      }
    }
    .field {
      font-size: 0.75rem;
      margin-right: 0.5rem;
    }
    .value {
      font-weight: bold;
    }
  }
}
</style>
